module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "landmark-product"
    }
  }, [_c('div', {
    staticClass: "landmark-product-top",
    style: ({
      background: ("url(" + _vm.topImgBg + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "landmark-product-title lp-hot",
    style: ({
      background: ("url(" + _vm.titleBg + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "home-module"
  }, [_c('div', {
    staticClass: "brandList clearfix"
  }, [_c('div', {
    staticClass: "brandList-item"
  }, [_c('ul', _vm._l((_vm.productlist.hotCityAdvertisementDTO.advList), function(item, index) {
    return _c('li', {
      directives: [{
        name: "mouseenter",
        rawName: "v-mouseenter"
      }],
      key: index,
      class: {
        active: index == 0
      },
      style: ({
        backgroundImage: ("url(" + (item.atturl) + ")")
      })
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: 'landmark-goods-list',
          query: {
            regionId: item.url,
            aname: item.aname
          }
        }
      }
    })], 1)
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "landmark-product-title lp-hd",
    style: ({
      background: ("url(" + _vm.titleBg + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "landmark-item product-list-2-6"
  }, [_c('ul', _vm._l((_vm.productlist.eastChinaAreaAdvertisementDTO.advList), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: 'landmark-goods-list',
          query: {
            regionId: item.url,
            aname: item.aname
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "height": "100%",
        "width": "100%"
      }
    })])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "landmark-product-title lp-hz",
    style: ({
      background: ("url(" + _vm.titleBg + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "landmark-item product-list-1-4"
  }, [_c('ul', _vm._l((_vm.productlist.inCentralChinaAdvertisementDTO.advList), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: 'landmark-goods-list',
          query: {
            regionId: item.url,
            aname: item.aname
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "height": "100%",
        "width": "100%"
      }
    })])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "landmark-product-title lp-hb",
    style: ({
      background: ("url(" + _vm.titleBg + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "landmark-item product-list-2-5"
  }, [_c('ul', _vm._l((_vm.productlist.inNorthChinaAdvertisementDTO.advList), function(item, index) {
    return _c('li', {
      class: {
        smallImg: index == 0 || index == 1 || index == 2
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: 'landmark-goods-list',
          query: {
            regionId: item.url,
            aname: item.aname
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "height": "100%",
        "width": "100%"
      }
    })])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "landmark-product-title lp-hn",
    style: ({
      background: ("url(" + _vm.titleBg + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "landmark-item product-list-1-3"
  }, [_c('ul', _vm._l((_vm.productlist.inSouthChinaAdvertisementDTO.advList), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: 'landmark-goods-list',
          query: {
            regionId: item.url,
            aname: item.aname
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "height": "100%",
        "width": "100%"
      }
    })])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "landmark-product-title lp-xb",
    style: ({
      background: ("url(" + _vm.titleBg + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "landmark-item product-list-2-5"
  }, [_c('ul', _vm._l((_vm.productlist.theNorthwestRegionAdvertisementDTO.advList), function(item, index) {
    return _c('li', {
      class: {
        smallImg: index == 0 || index == 1 || index == 2
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: 'landmark-goods-list',
          query: {
            regionId: item.url,
            aname: item.aname
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "height": "100%",
        "width": "100%"
      }
    })])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "landmark-product-title lp-xn",
    style: ({
      background: ("url(" + _vm.titleBg + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "landmark-item product-list-2-5"
  }, [_c('ul', _vm._l((_vm.productlist.inTheSouthwestAdvertisementDTO.advList), function(item, index) {
    return _c('li', {
      class: {
        smallImg: index == 0 || index == 1 || index == 2
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: 'landmark-goods-list',
          query: {
            regionId: item.url,
            aname: item.aname
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "height": "100%",
        "width": "100%"
      }
    })])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "landmark-product-title lp-db",
    style: ({
      background: ("url(" + _vm.titleBg + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "landmark-item product-list-1-3"
  }, [_c('ul', _vm._l((_vm.productlist.inTheNortheastAdvertisementDTO.advList), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: 'landmark-goods-list',
          query: {
            regionId: item.url,
            aname: item.aname
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "height": "100%",
        "width": "100%"
      }
    })])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "landmark-product-title lp-gat",
    style: ({
      background: ("url(" + _vm.titleBg + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "landmark-item product-list-1-3"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, _vm._l((_vm.productlist.specialAreaAdvertisementDTO.advList), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: 'landmark-goods-list',
          query: {
            regionId: item.url,
            aname: item.aname
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "height": "100%",
        "width": "100%"
      }
    })])], 1)
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-586c524c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/landmark-superior-product/index.vue
// module id = 1609
// module chunks = 1